import { Button } from '@cbhq/cds-web/buttons';
import { VStack } from '@cbhq/cds-web/layout';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@cbhq/cds-web/overlays';

import { FreeTrialField } from ':cloud/widgets/waasProjects/projectFormFields/PaymentMethodField';

interface ConfirmPaymentModalProps {
  onRequestClose: () => void;
  handleConfirm: () => void;
  handleChangePaymentMethod: () => void;
  isLoading?: boolean;
  visible: boolean;
}
export function ConfirmPaymentModal({
  onRequestClose,
  handleConfirm,
  isLoading,
  visible,
}: ConfirmPaymentModalProps) {
  return (
    <Modal visible={visible} onRequestClose={onRequestClose} hideDividers width={600}>
      <ModalHeader title="Confirm payment method" />
      <ModalBody>
        <VStack gap={3}>
          {/* TODO(go/j/CCPLT-551): Need a way to add a credit card when integrating free credits API */}
          <FreeTrialField />
        </VStack>
      </ModalBody>
      <ModalFooter
        primaryAction={
          <Button onPress={handleConfirm} loading={isLoading}>
            Confirm
          </Button>
        }
      />
    </Modal>
  );
}
